import React, { useEffect, useState } from "react";
import reactCSS from 'reactcss';
import { TwitterPicker } from 'react-color';
import { Button, Form } from "react-bootstrap";
import { IColorStyle } from "../data/Query";
import { scales } from "../colorscaleUtils";
import Gradient from "./Gradient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

type ColorSelectorProps = {
    config: IColorStyle;
    onUpdate: Function
};

enum ColorType {
    Solid = "SOLID",
    Ramp = "RAMP"
};

const ColorSelector = (props: ColorSelectorProps) => {
    const [colorStyle, setColorStyle] = useState<IColorStyle>({ ...props.config });
    const [value, setValue] = useState<ColorType>(props.config && props.config.color != null ? ColorType.Solid : ColorType.Ramp);
    const [showSolidConfig, setShowSolidConfig] = useState(false);

    useEffect(() => {
        //console.log('config', props.config);
        setValue(props.config && props.config.color != null ? ColorType.Solid : ColorType.Ramp);
        setColorStyle(props.config);
      }, [props]);

    const defaultSolidColor: string = '#0693E3';
    const defaultRampColor: string = 'Greys';

    const styles = reactCSS({
        'default': {
            color: {
                width: '35px',
                height: '35px',
                borderRadius: '5px',
                backgroundColor: colorStyle.color ? `${colorStyle.color}` : defaultSolidColor
            },
            swatch: {
                display: 'inline-block',
                cursor: 'pointer',
            },
            popover: {
                position: 'absolute',
                zIndex: '2',
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            },
        }
    });

    const handleChange = (val: any) => {
        setValue(val.currentTarget.value);

        let style: IColorStyle = {...colorStyle};

        switch(val.currentTarget.value)
        {
            case ColorType.Solid:
                style.color = defaultSolidColor;
                style.inverse = undefined;
                style.scale = null;
                break;
            case ColorType.Ramp:
                style.color = null;
                style.inverse = false;
                style.scale = defaultRampColor;
                break;
        }

        setColorStyle(style);
    }

    const renderSolidColor = () => {
        return (
            <div>
                <div style={styles.swatch} onClick={(e: any) => {
                    colorStyle.color = colorStyle.color ? colorStyle.color : defaultSolidColor;
                    setShowSolidConfig(!showSolidConfig);
                }}>
                    <div style={styles.color} />
                </div>
                {showSolidConfig ? <div style={styles.popover}>
                    <div style={styles.cover} onClick={() => { setShowSolidConfig(false); }} />
                        <TwitterPicker color={colorStyle.color} onChangeComplete={(color: any) => {
                            setColorStyle({ scale: null, color: color.hex });
                            props.onUpdate({ scale: null, color: color.hex });
                        }} />
                    </div> : null }
            </div>
        );
    }

    const renderRampColor = () => {
        return (
            <div>
                <div className="d-flex flex-row align-items-center mb-2">
                <div className="mr-2">
                    <Form.Control as="select" size="sm" name="colorscaleName"
                        onChange={(e: any) => {
                            setColorStyle({ scale: e.target.value, color: null });
                            props.onUpdate({ scale: e.target.value, color: null });
                        } }
                        value={colorStyle != null && colorStyle.scale != null ? colorStyle.scale : undefined}>
                        {Object.keys(scales).map((name: string, i: number) => (
                            <option key={i} value={name}>{name}</option>
                        ))}
                    </Form.Control>
                </div>
                <div className="d-flex flex-row align-items-center">
                    <Gradient width={200} height={32} ramp={scales[colorStyle.scale ? colorStyle.scale : defaultRampColor]} inverse={colorStyle.inverse!} />
                    <Button
                        className="ml-2"
                        title="Reverse"
                        variant="dark" onClick={() => {
                        const style: IColorStyle = {...colorStyle};
                        style.inverse = !style.inverse;
                        setColorStyle(style);
                        props.onUpdate(style);
                    }}>
                        <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                    </div>
                </div>
            </div>
        );      
    }

    return (
        <>
            <div className="mb-2">
                <Form.Check inline label="Solid" type="radio" name="radio" onChange={handleChange} value={ColorType.Solid} checked={value === ColorType.Solid} />
                <Form.Check inline label="Scale" type="radio" name="radio" onChange={handleChange} value={ColorType.Ramp} checked={value === ColorType.Ramp} />
            </div>
            {value === ColorType.Solid ? renderSolidColor() : renderRampColor()}
        </>
    );
}

export default ColorSelector;
